/*
 * spurtcommerce
 * version 4.3
 * http://www.spurtcommerce.com
 *
 * Copyright (c) 2020 piccosoft ltd
 * Author piccosoft ltd <support@piccosoft.com>
 * Licensed under the MIT license.
 */
import { Component, OnInit } from '@angular/core';
import { ListsService } from 'src/core/lists/lists.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-spurt-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  public headerValue = '';
  public HeaderData:any;
  constructor(private api: ListsService) { }

  ngOnInit() {
    this.headerValue = environment.storename;

    this.Header(this.headerValue);

  }
  // dowload link for mobile app
  downloadApp() {
    window.open(
      'https://play.google.com/store/apps/details?id=com.piccosoft.spurtcommerce'
    );
  }

  Header(i) {
    const data = {
      headerId: i
    };
    this.api.getBannerList(data).subscribe((res: any) => {
      this.HeaderData = res.data;
      // console.log('Header-->',this.HeaderData)
    });
  }
}
